import { getToken, getUser } from "../../Utilities/Common";
import { getWithParamsAPICall, postAPICall } from "../axiosMethodCall";

export const getAssessmentHistory = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "assessments/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getAssessmentForPrint = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "assessments/get_for_print",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const printEkas = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "prints/pdf",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const printEpress = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "prints/pdf2",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
